import React, { useState, useEffect } from 'react'

import Loading from '../../../../templates/UI/Loading/Loading'

import TopCampaignsOfTheWeek from '../TopCampaignsOfTheWeek/TopCampaignsOfTheWeek'
import OpenIssues from '../OpenIssues/OpenIssues'
import BizdevSummary from '../BizdevSummary/BizdevSummary'
import CreditChecks from '../CreditChecks/CreditChecks'
import BizdevFollowupQueue from '../BizdevFollowupQueue/BizdevFollowupQueue'
import { useAuth, useProtectedPage } from '../../../../context/AuthContext'
import CampaignList from '../../../Advertiser/CampaignList/CampaignList'
import CampaignsInSetup from '../CampaignsInSetup/CampaignsInSetup'
import BizdevTeam from '../BizdevTeam/BizdevTeam'

export default function BizdevDirector({ manager, showSystemMessage }) {
    const auth = useAuth()
    useProtectedPage(auth.permissions, 'bizdev_director_dashboard')

    const [dataLoaded, setDataLoaded] = useState(true)

    return (
        <React.Fragment>
            {dataLoaded ? (
                <React.Fragment>
                    <div className="page-header d-flex align-items-center">
                        <h1 className="mb-h1">Business Development Director</h1>
                    </div>
                    <div className="row">
                        <div className="col-lg-4">
                            <BizdevSummary manager={manager} showSetManager={true} />
                            <BizdevFollowupQueue manager={manager} type="advertiser" />
                        </div>
                        <div className="col-lg-8">
                            <BizdevTeam showSystemMessage={showSystemMessage} mode="team" />
                            <div className="row">
                                <div className="col-lg-6">
                                    <TopCampaignsOfTheWeek showSystemMessage={showSystemMessage} />
                                    <OpenIssues manager={manager} showSystemMessage={showSystemMessage} />
                                </div>
                                <div className="col-lg-6">
                                    <CreditChecks manager={manager} showSystemMessage={showSystemMessage} />       
                                    <CampaignsInSetup manager={manager} managerType={'BIZDEV'} showSystemMessage={showSystemMessage} />                             
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            ) : (
                <Loading></Loading>
            )}
        </React.Fragment>
    )
}
